export const FETCH_RECENTS_REQUEST = 'FETCH_RECENTS_REQUEST';
export const FETCH_RECENTS_SUCCESS = 'FETCH_RECENTS_SUCCESS';
export const FETCH_RECENTS_FAILURE = 'FETCH_RECENTS_FAILURE';
export const ADD_RECENTS_REQUEST = 'ADD_RECENTS_REQUEST';
export const ADD_RECENTS_SUCCESS = 'ADD_RECENTS_SUCCESS';
export const ADD_RECENTS_FAILURE = 'ADD_RECENTS_FAILURE';
export const DELETE_RECENTS_REQUEST = 'DELETE_RECENTS_REQUEST';
export const DELETE_RECENTS_SUCCESS = 'DELETE_RECENTS_SUCCESS';
export const DELETE_RECENTS_FAILURE = 'DELETE_RECENTS_FAILURE';
export const TOGGLE_RECENT_AS_FAVORITE = 'TOGGLE_RECENT_AS_FAVORITE';
export const UPDATE_RECENTS_WITH_FAVORITES = 'UPDATE_RECENTS_WITH_FAVORITES';
export const REORDER_RECENTS = 'REORDER_RECENTS';
